
import { push } from 'connected-react-router';
import fetch from 'isomorphic-fetch';
import { put, call } from 'redux-saga/effects'
import { hasValue } from '../Helpers/Utilities';
import localforage from 'localforage';
import { includes } from 'ramda';
/**
//  * Method to make all types of API calls
//  * @param url The api url to call
//  * @param method GET' | 'PUT' | 'POST' | 'DELETE
//  * @param headers request headers
//  * @param body Post or Put body
//  * @param token authentication token
//  */
// export default function* request(
//   url: string, 
//   method: 'GET' | 'PUT' | 'POST' | 'DELETE',
//   headers?: any,
//   body?: any, 
//   token?: string
//   ) {
//   if(body) {
//     body = JSON.stringify(body);
//   }
//   const options = { method, headers,  body };
//   try {
//       const response = yield call(fetch, url, addHeader(options, token));
//       return response;
//   } catch (e) {
//      const errorEffect = getErrorEffect(e); // replaces handleError
//      if (errorEffect) {
//         yield errorEffect;
//      }
//   }
// }

export function* httpPost(
  url: string,
  body: any,
  token: string
) {
  try {
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string = yield(call(getClientId));
    if(hasValue(clientId)) {
      if(includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }
    const options = {method: 'POST', body: JSON.stringify(body)};
    const response: {} = yield call(fetch, url, addHeader(options, token));
    return response;
  } catch (e) {
    const errorEffect = getErrorEffect(e); // replaces handleError
    if (errorEffect) {
       yield errorEffect;
    }
  }
}
export function* httpPut(
  url: string,
  body: any,
  token: string
) {
  try {
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string = yield(call(getClientId));
    if(hasValue(clientId)) {
      if(includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }
    const options = {method: 'PUT', body: JSON.stringify(body)};
    const response: {} = yield call(fetch, url, addHeader(options, token));
    return response;
  } catch (e) {
    const errorEffect = getErrorEffect(e); // replaces handleError
    if (errorEffect) {
       yield errorEffect;
    }
  }
}

export function* httpGet(
  url: string,
  token: string
) {
  try {
    // url = `${url}?clientId=CRM`
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string = yield(call(getClientId));
    if(hasValue(clientId)) {
      if(includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }
    const response: {} = yield call(fetch, url, addHeader({method: 'GET'}, token));
    return response;
  } catch (e) {
    const errorEffect = getErrorEffect(e); // replaces handleError
    if (errorEffect) {
       yield errorEffect;
    }
  }
}

export const httpGetAsync = async(
  url: string,
  token: string
) => {
  try {
    // url = `${url}?clientId=CRM`
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string | undefined = await getClientId() as (string | undefined);
    if(hasValue(clientId)) {
      if(includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }
  
    const response = await fetch(url, addHeader({method: 'GET'}, token));
    return response;
  } catch (e) {
    const errorEffect = getErrorEffect(e); // replaces handleError
    if (errorEffect) {
       // yield errorEffect;
    }
  }
}

export function* httpDelete(
  url: string,
  token: string
) {
  try {
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string = yield(call(getClientId));
    if(hasValue(clientId)) {
      if(includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }
    const response: {} = yield call(fetch, url, addHeader({method: 'DELETE'}, token));
    return response;
  } catch (e) {
    const errorEffect = getErrorEffect(e); // replaces handleError
    if (errorEffect) {
       yield errorEffect;
    }
  }
}

/**
 * Add headers to api
 * @param options 
 * @param token 
 */
function addHeader(options: any = {}, token?: string) {
  const newOptions = { ...options };
  if (!options.headers) {
    newOptions.headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...options.headers,
    };
  }
  // Add bearer token if it exists
  if (token) {
    newOptions.headers.Authorization = `Bearer ${token}`;
  }

  return newOptions;
}


/**
 * Add headers to api
 * @param options 
 * @param token 
 */
//  async function addHeader(options: any = {}, token?: string, clientId?: string | null) {  
//   const updatedOptions = hasValue(clientId) 
//     ? {...options, clientId: clientId} : { ...options }
//   const newOptions = { ...updatedOptions };  
//   if (!options.headers) {
//     newOptions.headers = {
//       Accept: 'application/json',
//       'Content-Type': 'application/json',
//       ...options.headers,
//     };
//   }
//   // Add bearer token if it exists
//   if (token) {
//     newOptions.headers.Authorization = `Bearer ${token}`;
//   }

//   return newOptions;
// }

function getErrorEffect(error: any) {
  if (error.code === 401) {
    return put(push('/login')); // returns the effect for the `request` generator to yeild
  }

  if (error.code === 400) {
    // return displayToast(error); // assuming `displayToast` is an effect that can be yielded directly
    console.log(error);
  }
}